import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { BlockUIModule } from 'primeng/blockui';

import { BlockUiComponent } from './block-ui.component';
import { BlockUiService } from './block-ui.service';
import { BasicBlockInterceptor } from './basic-block-interceptor';


@NgModule({
	declarations: [
		BlockUiComponent
	],
	imports: [
		CommonModule,
		BlockUIModule /* primeNg */
	],
	providers: [
		BlockUiService,
		{ provide: HTTP_INTERCEPTORS, useClass: BasicBlockInterceptor, multi: true }
	],
	exports: [
		BlockUiComponent
	]
})
export class BlockUiModule { }